<template>
  <el-timeline class="pad">
    <el-timeline-item>
      <h3>绝对禁忌症</h3>
      <AbsoluteContradictions />
    </el-timeline-item>
    <el-timeline-item>
      <h3>既往病史</h3>
      <MedicalHistory ref="MedicalHistoryRef" :teleNum="teleNum" :disabled="disabled" />
    </el-timeline-item>
  </el-timeline>
</template>

<script>
import AbsoluteContradictions from "./AbsoluteContradictions";
import MedicalHistory from "./MedicalHistory";

export default {
  name: "selfStatement",
  components: {
    AbsoluteContradictions,
    MedicalHistory,
  },
  props: {
    teleNum: String,
    disabled: Boolean,
  },
  data() {
    return {
      registered: false,
      //既往病史
    };
  },
  methods: {
    getMedicalHistory() {
      return this.$refs.MedicalHistoryRef.form;
    },
  },
};
</script>

<style scoped lang=less>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.highlight {
  color: red;
}

/* .pad {
  padding-left: 40px;
  padding-right: 40px;
} */

.fr {
  float: right;
}
</style>